import { useState } from "react";
import ImageGallery from "../../components/ImageGallery/ImageGallery";
import AdditionalInfo, { hasAdditionalInfo } from "../../components/InfoRow/AdditionalInfo";
import DiamondDetailsContent from "../../components/InfoRow/DiamondDetailsContent";
import ParameterDetails from "../../components/InfoRow/ParameterDetails";
import Accordion from "../../components/tabs/Accordion";

export default function DiamondDetails({ data,primaryColor,primaryFontColor }) {


    const [logoError, setLogoError] = useState(false);

    function numberWithCommas(x) {
        if (x) {
            return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
            return "0.00";
        }
    }
    const CopyIcon = () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <rect
                x="9"
                y="9"
                width="11"
                height="11"
                rx="2"
                stroke={primaryColor}
                strokeWidth="2"
            />
            <path
                d="M5 15V6C5 4.89543 5.89543 4 7 4H16"
                stroke={primaryColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );

    const ExternalLinkIcon = () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path
                d="M9 5H7C5.89543 5 5 5.89543 5 7V17C5 18.1046 5.89543 19 7 19H17C18.1046 19 19 18.1046 19 17V15"
                stroke={primaryColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10 14L19 5"
                stroke={primaryColor}
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M14 5H19V10"
                stroke={primaryColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );

    const galleryItems = [
        {
            type: "image",
            name: "image",
            src: data?.image,
            sample: data?.sample,
        },
        ...(data?.heart
            ? [{ type: "image", name: "heart", src: data.heart }]
            : []),
        ...(data?.arrow
            ? [{ type: "image", name: "arrow", src: data.arrow }]
            : []),
        ...(data?.asset
            ? [{ type: "image", name: "asset", src: data.asset }]
            : []),
        ...(data?.video
            ? [{ type: "video", name: "video", src: data.video }]
            : []),
    ];

    const tabs = [
        {
            key: "diamond",
            title: "DIAMOND DETAILS",
            content: (
                <>
                    <DiamondDetailsContent data={data} />
                </>
            ),
        },
        {
            key: "param",
            title: "PARAMETERS DETAILS",
            content: <ParameterDetails data={data} />,
        },
        ...(hasAdditionalInfo(data)
            ? [{
                key: "additional",
                title: "ADDITIONAL DETAILS",
                content: <AdditionalInfo data={data} />,
            }]
            : []),
    ];
    const handelCopy = () => {
        navigator.clipboard.writeText(data?.certificate);
        alert("Certificate number copied to clipboard");
    };

    return (
        <>
            <div
                className="logo-container"
                style={{ backgroundColor: data?.navBarColor || "#F8F8F8" }}
            >
                {!data?.company_logo && !data?.company_name ? (
                    <svg
                        stroke={data?.navBarFont || primaryColor}
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 512 512"
                        height="40px"
                        width="50px"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="30"
                            d="m35.42 188.21 207.75 269.46a16.17 16.17 0 0 0 25.66 0l207.75-269.46a16.52 16.52 0 0 0 .95-18.75L407.06 55.71A16.22 16.22 0 0 0 393.27 48H118.73a16.22 16.22 0 0 0-13.79 7.71L34.47 169.46a16.52 16.52 0 0 0 .95 18.75zM48 176h416"
                        />
                        <path
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="30"
                            d="m400 64-48 112-96-128M112 64l48 112 96-128m0 400-96-272m96 272 96-272"
                        />
                    </svg>
                ) : (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                        }}
                    >
                        {data?.company_logo && !logoError && (
                            <img
                                src={data.company_logo}
                                alt={data.company_name || "Company Logo"}
                                height={50}
                                onError={() => setLogoError(true)}
                            />
                        )}

                        {data?.company_name && (
                            <div
                                className="cname-title"
                                style={{
                                    color: data?.navBarFont || primaryColor,
                                }}
                            >
                                {data.company_name}
                            </div>
                        )}
                    </div>
                )}
            </div>
            <div className="container-fluid">
                <div className="page">
                    <div className="left">
                        <ImageGallery primaryColor={primaryColor} items={galleryItems} data={data} />
                    </div>

                    <div className="right">
                        <div
                            className="diamond-detail-title"
                            style={{ marginBottom: 15, marginTop: 10 }}
                        >
                            {data?.shape}{" "}
                            {data?.carat ? `${data?.carat.toFixed(2)}ct` : null}{" "}
                            {data?.color} {data?.clarity} {data?.cut}{" "}
                            {data?.polish} {data?.symmetry} {data?.fluorescence}
                        </div>
                        {data?.showsharecertificate && (
                            <div className="certi-link">
                                <a href={data?.certificate_link} style={{color:primaryColor}}>
                                    {data?.lab} : {data?.certificate}{" "}
                                    <span
                                        style={{ marginLeft: 5, marginTop: 2 }}
                                    >
                                        <ExternalLinkIcon />
                                    </span>
                                </a>
                                <span
                                    style={{
                                        marginLeft: 5,
                                        marginTop: 2,
                                        cursor: "pointer",
                                    }}
                                    title="Copy certificate number"
                                    onClick={handelCopy}
                                >
                                    <CopyIcon />
                                </span>
                            </div>
                        )}

                        {data?.showshareprice && (
                            <div className="price-title-sec">
                                <div className="perct-price">
                                    {data?.ourPriceShareExchangeSymbol}/CT{" "}
                                    {numberWithCommas(
                                        data?.ourRateShareExchange,
                                    )}
                                </div>
                                <div className="price-title">
                                    {data?.ourPriceShareExchangeSymbol}
                                    {numberWithCommas(
                                        data?.ourPriceShareExchange,
                                    )}
                                </div>
                            </div>
                        )}
                        <Accordion primaryColor={primaryColor} primaryFontColor={data?.naturalFontColor ? primaryFontColor : "#fff"} items={tabs} />
                        {/* <Tabs tabs={tabs} /> */}
                    </div>
                </div>
            </div>
        </>
    );
}
